import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import { SvgIcon } from "@mui/material";
export default function FormIcon(props) {
    var children = props.children, rest = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(SvgIcon, rest, children, " ");
}
